import { Menu } from "antd";
import { useMyAccessProfileV2 } from "../../../apis/tryst/get-my-access-profile";
import { MenuItem, Spinner } from "ui";
import { Appointment } from "@elixir/types";
import useAssignDoctorToApt from "../../../apis/tryst/use-assign-doctor-to-apt";
import { UserDoctorRegularIcon } from "@elixir/icons";
import useQueueStore from "../../../stores/queue-store";

function SelectDoctorMenu({
  aptData,
  onSelect,
}: {
  aptData: Appointment;
  onSelect?: (docId: string) => void;
}) {
  const selectedClinicId = useQueueStore((state) => state.clinicId);
  const { data: myAccessProfile } = useMyAccessProfileV2({
    clinicId: selectedClinicId,
  });
  const {
    mutateAsync: assignDoctorToApt,
    isLoading,
    variables,
  } = useAssignDoctorToApt();

  return (
    <Menu className="dr-rounded-8 dr-overflow-hidden dr-w-200 hide-submenu-arrow">
      {myAccessProfile?.doctors.map((item) => {
        return (
          <MenuItem
            key={item.oid}
            onClick={async () => {
              if (isLoading) {
                return;
              }

              await assignDoctorToApt({
                appointment: aptData,
                doctorId: item.oid,
              });

              onSelect?.(item.oid);
            }}
            title={item.name}
            icon={
              isLoading && variables?.doctorId === item.oid ? (
                <Spinner size={16} />
              ) : (
                <UserDoctorRegularIcon />
              )
            }
            enableTooltip={true}
          />
        );
      })}
    </Menu>
  );
}

export default SelectDoctorMenu;
